import { apiFetch } from "./client.ts";

export interface WorkflowRun {
  id: string;
  workflowId: string;
  correlationId: string;
  status: string;
  currentStep: string | null;
  triggerEventId: string | null;
  errorMessage: string | null;
  startedAt: string;
  completedAt: string | null;
  updatedAt: string;
}

export interface WorkflowStep {
  id: string;
  stepName: string;
  status: string;
  attempt: number;
  input: unknown;
  output: unknown;
  errorMessage: string | null;
  startedAt: string | null;
  completedAt: string | null;
  createdAt: string;
}

export async function listWorkflowRuns(
  token: string,
  params: { workflowId?: string; status?: string; limit?: number } = {},
): Promise<WorkflowRun[]> {
  const qs = new URLSearchParams();
  if (params.workflowId) qs.set("workflowId", params.workflowId);
  if (params.status) qs.set("status", params.status);
  if (params.limit) qs.set("limit", String(params.limit));
  const query = qs.toString() ? `?${qs.toString()}` : "";
  return apiFetch<WorkflowRun[]>(`/api/v1/workflows/runs${query}`, { token });
}

export async function getWorkflowRun(
  token: string,
  runId: string,
): Promise<WorkflowRun & { steps: WorkflowStep[] }> {
  return apiFetch<WorkflowRun & { steps: WorkflowStep[] }>(`/api/v1/workflows/runs/${runId}`, { token });
}

export async function triggerWorkflow(
  token: string,
  workflowId: string,
  input: Record<string, unknown> = {},
): Promise<{ runId: string; correlationId: string; status: string; startedAt: string }> {
  return apiFetch<{ runId: string; correlationId: string; status: string; startedAt: string }>(
    "/api/v1/workflows/trigger",
    {
      method: "POST",
      token,
      body: JSON.stringify({ workflowId, input }),
    },
  );
}
